/**
 * Hands a fetched file to the browser as a DOWNLOAD.
 *
 * A file is fetched through the authenticated client and saved from an object URL — never linked
 * with an `<a href>` at the endpoint, which carries no bearer token and would ask the browser to
 * render, on this origin, content the server is merely holding. The URL is revoked at once: it is
 * dead outside the tab that made it, and nothing here previews.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = window.document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;
  window.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
